var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("prefix"),_vm._v(" "),_c('span',{class:_vm.className},[_vm._v(_vm._s(_vm._f("registrationCategoryStatus")(_vm.humanStatus)))]),_vm._v(" "),_vm._t("postfix")],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e97f800","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Assets/components/RegistrationCategories/Tickets/Utility/StatusBadge.vue
// module id = 2485
// module chunks = 1